var sc_tmfy_app_global_thmvals={
    "Dawn":{
        "3.0.0":{            
            //store_btn_placeholder:'',
            //store_variant_select_selector:'',
            //store_btn_add_to_cart_selector: '',
            css:'#div-sc-tmfy-07092020 .btn-timify{ background: #000000; border: 0px solid #000000; color: #FFFFFF; font-weight: normal; font-weight: 500;font-size: 15px; font-family: Assistant, sans-serif; font-style: normal; border-radius:0px;}',
            //process_tasks:function(){}
        }
    }
};